import React from 'react';
import { observer } from 'mobx-react';
import { Switch, Route, useLocation, useRouteMatch, Redirect } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import { useDataStore } from 'state/DataStore';

import getRouteKey from 'utilities/getRouteKey';
import joinPath from 'utilities/joinPath';
import Page from 'components/Page';
import Container from 'components/sidebar/Container';
import Content from 'components/sidebar/Content';
import PageContainer from 'components/PageContainer';

import CategoriesSidebar from './CategoriesSidebar';
import Category from './Category';


const Categories = observer(({ page }) => {
    const location = useLocation();
    const match = useRouteMatch();
    const dataStore = useDataStore();
    const { data: { unit_categories } } = dataStore;
    
    return (
        <Page>
            <Container>
                <CategoriesSidebar categories={unit_categories} />
                
                <Content>
                    <PageContainer>
                        <AnimatePresence>
                            <Switch location={location} key={getRouteKey(location, match)}>
                                {/* Redirect from parent page to first category */}
                                <Route exact path={match.path}>
                                    <Redirect to={joinPath(match.path, unit_categories[0]?.slug)} />
                                </Route>
                                
                                <Route path={joinPath(match.path, ':categorySlug')}>
                                    <Category />
                                </Route>
                            </Switch>
                        </AnimatePresence>
                    </PageContainer>
                </Content>
            </Container>
        </Page>
    );
});


export default Categories;
